import React from 'react'
import { Stepper } from '@babylon/medkit'

import StepTitle from './StepTitle'

interface Props {
  activeStep: number
  steps: string[]
  pageTitle?: string
  content?: string[]
}

const StepHeader = ({ activeStep, steps, pageTitle, content }: Props) => (
  <>
    <Stepper activeStep={activeStep} steps={steps} />
    <StepTitle pageTitle={pageTitle} content={content} />
  </>
)

export default StepHeader
